import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "react-router";
// The app stylesheet ships as a same-origin asset (Tailwind compiled at build time by the
// @tailwindcss/vite plugin), referenced as a <link> via the links export below.
import stylesHref from "../index.css?url";

export const links = () => [
  // Favicons / PWA icons ported from the old index.html. They live in public/ and are served
  // same-origin.
  { rel: "icon", type: "image/png", href: "/lemon-pie-64.png" },
  { rel: "apple-touch-icon", href: "/lemon-pie-192.png" },
  { rel: "stylesheet", href: stylesHref },
];

// Document-level metadata, ported verbatim from the old index.html so the deployed app keeps
// its title, description, theme color, and Open Graph / Twitter cards. React Router's <Meta />
// renders these into <head>.
export const meta = () => [
  { title: "Lemon Pi" },
  {
    name: "description",
    content: "Lemon Pi — a local-first time tracker. Time, sliced.",
  },
  { name: "theme-color", content: "#FFE94A" },
  { property: "og:type", content: "website" },
  { property: "og:title", content: "Lemon Pi" },
  {
    property: "og:description",
    content: "A local-first time tracker. Time, sliced.",
  },
  { property: "og:image", content: "/lemon-pie.png" },
  { name: "twitter:card", content: "summary" },
  { name: "twitter:title", content: "Lemon Pi" },
  {
    name: "twitter:description",
    content: "A local-first time tracker. Time, sliced.",
  },
  { name: "twitter:image", content: "/lemon-pie.png" },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <Meta />
        <Links />
      </head>
      {/* The body background classes are ported from the old index.html <body> so the
          dark-mode shell paints before the React tree mounts. */}
      <body className="bg-lemon-50 dark:bg-ink transition-colors duration-200">
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function Root() {
  return <Outlet />;
}
